import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { ContainerHeader, SpinnerLoader, Typography } from 'shared/ui'
import { getAriaLabel, getCDNAssetURL } from 'shared/lib'
import { type IDiscoverPagesKey } from 'pages/discover/lib/types'
import { DISCOVER_PAGES_DATA_MAP } from 'pages/discover/lib/discoverData'
import { useDiscoverContext } from 'pages/discover/context/context'
import { BoxesList } from 'pages/discover/ui/BoxesList/BoxesList'
import styles from './styles.module.scss'

type ISectionsPageProps = {
  page: IDiscoverPagesKey
}

export const SectionsPage = observer(({ page }: ISectionsPageProps) => {
  const store = useDiscoverContext()
  const { loading, setPage } = store
  const pageData = DISCOVER_PAGES_DATA_MAP[page]

  if (!pageData) return null

  useEffect(() => {
    setPage(page)
  }, [page])

  if (loading) {
    return <SpinnerLoader ariaLabel={'SectionsPage'} />
  }

  return (
    <div className={styles.wrap} aria-label={getAriaLabel(pageData.title, 'Content')}>
      <ContainerHeader
        title={pageData.title}
        titleVariant={'heading-lg'}
        paddingTop={64}
        paddingBottom={32}
        paddingLeft={0}
        paddingRight={0}
        isAutoHeight={true}
        ariaLabel={getAriaLabel(pageData.title, 'Header')}
      />

      <img className={styles.image} alt={pageData.title} src={getCDNAssetURL(pageData.image)} />

      <Typography
        ariaLabel={'Subheading'}
        tag='div'
        variant={'body-lg-medium'}
        marginBottom={4}
        color={'var(--content-primary-primary)'}
        marginTop={22}
      >
        {pageData.subtitle}
      </Typography>
      <Typography
        ariaLabel={'Description'}
        variant={'body-md-regular'}
        color={'var(--content-primary-tertiary)'}
      >
        {pageData.description}
      </Typography>

      <div style={{ paddingTop: 40 }} aria-label={getAriaLabel('List')}>
        <BoxesList />
      </div>
    </div>
  )
})
